module.exports = __webpack_public_path__ + "static/olawa-02f239b107adb3e02ec6a4392f73356a.png";